import { Stack } from '@mui/system';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Box } from '@mui/material';

import {store} from '../redux/store'
import {setAsLoaded} from '../redux/slices/userSettings'
import dayjs from 'dayjs';
import {ApplyDateJs} from "../components/date";
import {ApplyDateJsIT} from "../components/date-it-IT";


function TransformDataForGrid(data, idField) {
    const rows = [];

    data.forEach(element => {
        const currentRow = {};
        Object.keys(element).forEach(k => {
            if (k === idField) currentRow.id = element[k];
            else currentRow[k] = element[k];
        });
        rows.push(currentRow);
    });
    return rows;
}

function TransformDataForGridArrayOfRows(rowArray, colNamesArray) {
    const rows = [];
    const containsId = colNamesArray.includes("id")
    let fakeId = 1;
    rowArray.forEach(row => {
        const currentRow = {};
        if (!containsId) currentRow["id"] = fakeId++
        for (let i = 0; i < colNamesArray.length; i+=1) {
            currentRow[colNamesArray[i]] = row[i];
        }
        rows.push(currentRow);
    });
    return rows;
}


function DownloadUserSettings() {
    const settingsLoaded = store.getState().userSettings.loaded;
    if (!settingsLoaded) {
        getData();
        store.dispatch(setAsLoaded());
    }

    alert(store.getState().userSettings.loaded);
    return 'ciao';
}

const getData = async () => {
    try {
      // const url = `${process.env.REACT_APP_LION_API_URL}/User/Settings`;
      // const response = await axios.get(url);

      const url = `api/User/Settings`;
      const response = await fetch(url, { method: "GET", });    
      const data = await response.json();

    } catch (error) {
      console.log(error);
    }
  }

  function TryParseIntDefault(strToParse, defaultIfError) {

    try {
        const result = parseInt(strToParse, 10);
        if (Number.isNaN(result)) {return defaultIfError;}
        return result;
    }
    catch (err) {
        return defaultIfError;
    }
}
function TryParseFloatDefault(strToParse, defaultIfError) {

  try {
      const result = parseFloat(strToParse);
      if (Number.isNaN(result)) {return defaultIfError;}
      return result;
  }
  catch (err) {
      return defaultIfError;
  }
}


function GetFilterDefFromMetadata(metadata, dataTypesInMetadata)  {
    // if (dataConnectionInfo === undefined || dataConnectionInfo === null) return [];
    const results = [];
    const colNames = Object.keys(metadata.columns);
    for (let i=0; i<colNames.length; i+=1) {
      const currentColName = colNames[i];
      if (metadata.columns[currentColName].visible) {
        const currentCondition = {
          conditionName: currentColName,
          dataType: dataTypesInMetadata === true ? metadata.columns[currentColName].dataType : 'unknown', 
          conditionSymbol: currentColName
        }
        results.push(currentCondition);  
      }

    }

    return results;
  }


function RandomId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

function isNumeric(str) {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

function GuessDataType(samples) {
  ApplyDateJs()
  //ApplyDateJsIT() //TODO: apply logic to parse at least in two cultures


  const TEXT_LENGTH_LIMIT = 300;

  let occurenciesTxt = 0;
  let occurenciesLongTxt = 0;
  let occurenciesNumber = 0;
  let occurenciesDatetime = 0;

  samples.forEach(sample => {
    try {
      if (sample === '') return;

      if (!isNaN(Number(sample))) {occurenciesNumber += 1; return};

      //if (dayjs(sample).isValid()) {occurenciesDatetime += 1; return;}
      if (sample.length > 1 && Date.parse(sample) !== null) {occurenciesDatetime += 1; return;}

      //if we are here it's text
      if (sample.length > TEXT_LENGTH_LIMIT) {occurenciesLongTxt += 1; return}
      else {occurenciesTxt += 1; return;}
    }
    catch (e) {}

  })

  if (occurenciesDatetime > occurenciesNumber && occurenciesDatetime > occurenciesTxt
      && occurenciesDatetime > occurenciesLongTxt) return 'datetime'
  
  if (occurenciesNumber > occurenciesDatetime && occurenciesNumber > occurenciesTxt
    && occurenciesNumber > occurenciesLongTxt) return 'number'
    
  //if we are here it's either a text or a longtext. If there is even 1 long text occurency we need to set it as long text
  if (occurenciesLongTxt > 0) return 'longtext'
  else return 'text';

}

async function CheckImageUrlExists(url) {
  let img = new Image();
  const imageLoadPromise = new Promise(resolve => {
    img.onload = resolve;
    img.onload = () => {img = null; resolve(true);}
    img.onerror = () => {img = null; resolve(false);}
    img.src = url;
});
  const result = await imageLoadPromise;
  return result;

}

function GetSnippetIdfromSnippetHtml(input) {
  const match = input.match(/\/img\/(\d+)\//);
  return match ? match[1] : null;
}

function GetImageSize(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    
    img.onerror = (err) => {
      reject(new Error("Failed to load image."));
    };
    
    img.src = dataUrl;
  });
}

function RandomInt(min, max) {
  // Ensure min and max are integers
  min = Math.ceil(min);
  max = Math.floor(max);

  // Returns a random integer between min and max (inclusive)
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
const MaxIntInArray = (intArray) => {
  let result = -10000000

  for (const i of intArray) {
    if (i > result) result = i
  }
  return result
}

function RandomGradientPairHex() {
  const hue = Math.floor(Math.random() * 360);
  const saturation = 60 + Math.random() * 20; // 60–80%
  const lightLightness = 75 + Math.random() * 10; // light
  const darkLightness = 25 + Math.random() * 10;  // dark

  return [
    hslToHex(hue, saturation, lightLightness),
    hslToHex(hue, saturation, darkLightness)
  ];
}
function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;

  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n =>
    l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

  const toHex = x =>
    Math.round(x * 255).toString(16).padStart(2, "0");

  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
}
function RandomGradientHex(count) {
  if (count < 2) {
    throw new Error("Gradient needs at least 2 colors");
  }

  const hue = Math.floor(Math.random() * 360);
  const saturation = 60 + Math.random() * 20; // 60–80%

  const minLightness = 25 + Math.random() * 5;  // dark end
  const maxLightness = 75 + Math.random() * 10; // light end

  const step = (maxLightness - minLightness) / (count - 1);

  return Array.from({ length: count }, (_, i) => {
    const lightness = minLightness + step * i;
    return hslToHex(hue, saturation, lightness);
  }).reverse();
}



export {TransformDataForGrid, TransformDataForGridArrayOfRows, DownloadUserSettings, TryParseIntDefault, TryParseFloatDefault, RandomId, GetFilterDefFromMetadata, GuessDataType,
      CheckImageUrlExists, GetSnippetIdfromSnippetHtml, GetImageSize, RandomInt,
      MaxIntInArray, RandomGradientPairHex, RandomGradientHex};